import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { SelectItem } from "primeng/api";

import { User } from "../user.model";
import { UserRepository } from "../user.repository";
import { Subscription } from "rxjs";
import { TeamRepository } from "../../team/team.repository";
import { NotifyService } from "../../notify/notify.service";
import { TOAST } from "../../notify/toast/toast-type.enum";
import { BackendErrorPipe } from "../../shared/backend/backend-error.pipe";
import { PasswordValidator } from "../login/password.validator";
import { ButtonDirective } from "primeng/button";
import { Tooltip } from "primeng/tooltip";
import { InputText } from "primeng/inputtext";

@Component({
  selector: "app-user-form-password",
  templateUrl: "./user-form-password.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    FormsModule,
    ReactiveFormsModule,
    Tooltip,
    InputText,
  ],
})
export class UserFormPasswordComponent implements OnInit, OnDestroy {
  userRepository = inject(UserRepository);
  formBuilder = inject(UntypedFormBuilder);
  notifyService = inject(NotifyService);
  private teamRepository = inject(TeamRepository);

  public readonly user = input<User>(undefined);
  public loading = false;
  public passwordForm: UntypedFormGroup;
  public teamList: SelectItem[] = [];
  protected subscription = new Subscription();

  ngOnInit() {
    this.createPasswordForm();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public changePassword() {
    if (!this.passwordForm.valid || !this.passwordsMatch(this.passwordForm)) {
      this.notifyService.toast(
        TOAST.WARN,
        "Please verify your password is strong enough and repeated passwords is the same.",
      );

      return;
    }

    this.loading = true;
    this.subscription.add(
      this.userRepository
        .changePassword(
          this.user().getId(),
          this.passwordForm.value.oldPassword,
          this.passwordForm.value.password,
        )
        .subscribe({
          next: (response) => {
            this.notifyService.toast(TOAST.INFO, "Password changed.");
            this.loading = false;
          },
          error: (error) => {
            this.handleError(error);
            this.loading = false;
          },
        }),
    );
  }

  private passwordsMatch(form: UntypedFormGroup): boolean {
    return (
      form.controls.password &&
      form.controls.passwordConfirm &&
      form.controls.password.value === form.controls.passwordConfirm.value
    );
  }

  private handleError(err) {
    this.notifyService.toast(
      TOAST.ERROR,
      <string>(
        new BackendErrorPipe().transform(err.error ? err.error : err, "string")
      ),
    );
  }

  private createPasswordForm() {
    this.passwordForm = this.formBuilder.group({
      oldPassword: ["", [Validators.required]],
      password: ["", [Validators.required, PasswordValidator.strong]],
      passwordConfirm: ["", Validators.required],
    });
  }
}
